export default {
  dashboard: '/dashboard',
  contact: '/contact',
  about: '/about',
  lcfcollection: '/lcfcollection',
  signup: '/signup',
  search: '/search',
  login: '/login',
  profile: '/profile',
  recoverpassword: '/recoverpassword',
  admin: '/admin',
  shoppingcart: '/shoppingcart',
  payment: '/payment',
  admin: '/admin',
  customerreview: '/customerreview',
};
